import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "k-memo-line relative-position" }
const _hoisted_2 = { class: "fw-600 fs-17px text-cool-gray-100" }

interface IProps {
  title: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KMemoLine' },
  __name: 'KMemoLine',
  props: {
    title: {}
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "title", {}, () => [
      _createElementVNode("span", _hoisted_2, _toDisplayString(__props.title), 1)
    ]),
    _renderSlot(_ctx.$slots, "content")
  ]))
}
}

})